import { render, staticRenderFns } from "./FilterPValue.vue?vue&type=template&id=482af052&"
import script from "./FilterPValue.vue?vue&type=script&lang=js&"
export * from "./FilterPValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482af052')) {
      api.createRecord('482af052', component.options)
    } else {
      api.reload('482af052', component.options)
    }
    module.hot.accept("./FilterPValue.vue?vue&type=template&id=482af052&", function () {
      api.rerender('482af052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/criterion/FilterPValue.vue"
export default component.exports